import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography, Alert } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";

export const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshUser } = useAuth();
  const success = searchParams.get("success");
  const error = searchParams.get("error");

  useEffect(() => {
    const handleCallback = async () => {
      console.log("[AuthCallback] Component mounted/params changed", {
        success,
        error,
        timestamp: new Date().toISOString(),
      });

      if (success === "true") {
        try {
          console.log(
            "[AuthCallback] OAuth success detected, waiting for cookies...",
          );
          // Refresh user data and force an authoritative fetch from the backend
          // Small delay to allow browser to process Set-Cookie from the redirect response
          await new Promise((r) => setTimeout(r, 250));

          console.log(
            "[AuthCallback] Calling refreshUser(true) for authoritative backend check",
          );
          await refreshUser(true);

          console.log(
            "[AuthCallback] User refreshed successfully, redirecting to home",
          );
          // Redirect to home
          setTimeout(() => {
            console.log("[AuthCallback] Navigating to /");
            navigate("/");
          }, 1000);
        } catch (err) {
          console.error("[AuthCallback] Error during callback handling:", err);
        }
      } else if (error) {
        console.warn("[AuthCallback] OAuth error detected:", { error });
        // Redirect to login with error
        setTimeout(() => {
          console.log("[AuthCallback] Redirecting to login due to error");
          navigate("/login?error=auth_failed");
        }, 2000);
      } else {
        console.warn("[AuthCallback] No success or error parameter detected");
        // Default redirect to login
        setTimeout(() => {
          console.log("[AuthCallback] Default redirect to login");
          navigate("/login");
        }, 2000);
      }
    };

    handleCallback();
  }, [success, error, navigate, refreshUser]);

  if (success === "true") {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress sx={{ mb: 2 }} />
        <Typography>Authentication successful! Redirecting...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          p: 3,
        }}
      >
        <Alert severity="error" sx={{ mb: 2 }}>
          Authentication failed. Redirecting to login...
        </Alert>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <CircularProgress />
    </Box>
  );
};
